import React from "react";
import HeaderToolbar from "./HeaderToolbar";
import TemplatesList from "./TemplatesList";

const TemplatesTable = (props) => {
  const {
    rows,
    totalRows,
    page,
    rowsPerPage,
    searchText,
    onSearchChange,
    onAddTemplate,
    onPageChange,
    onRowsPerPageChange,
    onEditTemplate,
    onDeleteTemplate,
  } = props;

  return (
    <>
      <HeaderToolbar
        searchText={searchText}
        onSearchChange={onSearchChange}
        onAddTemplate={onAddTemplate}
      />
      <TemplatesList
        rows={rows}
        totalRows={totalRows}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        onEditTemplate={onEditTemplate}
        onDeleteTemplate={onDeleteTemplate}
      />
    </>
  );
};

export default TemplatesTable;
